import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize'
})
export class CapitalizePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }
    return value
      .toLowerCase()
      .replace(/(?:^|\s|\-|_)[a-z]/g, (match) => match.toUpperCase())
      .replace(/([A-Z])([A-Z]+)/g, (m, p1, p2) => p1 + p2.toLowerCase());
  }
}
